import store from 'store2'

import post from '../../../lib/post'

export default function(o,data,id,changes,collection,done){

  var ombStore = store.namespace('omb')

  var changes = _.mapValues(_.keyBy(changes,'id'),'value')

  console.log('changes',changes)

  post(
    'data',
    {
      token: ombStore('token'),
      type: 'update',
      collection: collection,
      id: id,
      changes: changes,
    },
    function(error, result){
      if(error){
        done(error)
      } else {
        o.sounds.beep.play()
        o.feedback.ok('document updated')
        var item = _.find(data,{_id:id})
        for(var i in changes){
          item[i] = changes[i]
        }
        done()
      }
    }
  )

}



// WEBPACK FOOTER //
// ./src/client/view/admin/lib/documentUpdate.js